import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    LeadSetWatched as LeadSetWatchedMutation,
    LeadSetWatchedVariables,
    LeadSetWatchedInputFieldInput,
    GetLead_lead as Lead,
} from 'nutshell-graphql-types';

import LEAD_SET_WATCHED from '../../../shared/graphql/mutations/lead-set-watched.graphql';

export const useUpdateLeadWatched = (): {
    updateLeadWatched: (params: {input: LeadSetWatchedInputFieldInput; lead: Lead}) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [leadSetWatched, {loading, error}] = useMutation<
        LeadSetWatchedMutation,
        LeadSetWatchedVariables
    >(LEAD_SET_WATCHED);

    return {
        updateLeadWatched: ({input, lead}: {input: LeadSetWatchedInputFieldInput; lead: Lead}) =>
            leadSetWatched({
                variables: {lead: input},
                optimisticResponse: {
                    // @ts-expect-error
                    __typename: 'Mutation',
                    leadSetWatched: {
                        __typename: 'LeadSetWatchedPayload',
                        lead: {
                            // @ts-expect-error
                            __typename: 'Lead',
                            ...lead,
                            isCurrentUserWatching: input.shouldWatch,
                        },
                    },
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
